(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["benefit-flip-cards"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setState(card, flipped) {
      card.classList.toggle('is-flipped', flipped);
      card.setAttribute('aria-expanded', flipped ? 'true' : 'false');
      var front = card.querySelector('[data-bfc-front]');
      var back = card.querySelector('[data-bfc-back]');
      if (front) front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
      if (back) back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
    }

    function initCard(card) {
      if (card.dataset.bfcInit) return;
      card.dataset.bfcInit = '1';
      setState(card, false);
      card.addEventListener('click', function () {
        setState(card, !card.classList.contains('is-flipped'));
      });
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('[data-bfc-card]'), initCard);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('[data-bfc-card]'), initCard);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-photo-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCpc(root) {
      if (root.dataset.cpcInit) return;
      root.dataset.cpcInit = '1';
      var track = root.querySelector('[data-cpc-track]');
      var prev = root.querySelector('[data-cpc-prev]');
      var next = root.querySelector('[data-cpc-next]');
      if (!track) return;
      var cards = Array.prototype.slice.call(track.children);
      if (cards.length === 0) return;

      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-cpc-dot]'));
      dots.forEach(function (b, i) {
        b.addEventListener('click', function () {
          track.scrollTo({ left: i * step(), behavior: 'smooth' });
        });
      });

      function step() {
        var styles = getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 16;
        return cards[0].offsetWidth + gap;
      }

      if (prev) prev.addEventListener('click', function () {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      });

      function update() {
        var idx = Math.round(track.scrollLeft / step());
        if (idx < 0) idx = 0;
        if (idx > cards.length - 1) idx = cards.length - 1;
        dots.forEach(function (d, i) {
          d.classList.toggle('is-active', i === idx);
        });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = (track.scrollLeft + track.clientWidth) >= (track.scrollWidth - 2);
      }

      var ticking = false;
      track.addEventListener('scroll', function () {
        if (!ticking) {
          window.requestAnimationFrame(function () { update(); ticking = false; });
          ticking = true;
        }
      }, { passive: true });
      var isDown = false, startX = 0, startScroll = 0;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        isDown = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });
      function endDrag() {
        if (!isDown) return;
        isDown = false;
        track.classList.remove('is-dragging');
        track.scrollTo({ left: Math.round(track.scrollLeft / step()) * step(), behavior: 'smooth' });
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointerleave', endDrag);

      window.addEventListener('resize', update);
      update();
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.cpc'), initCpc);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.cpc');
      if (el) initCpc(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["info-modal"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initModal(root) {
      var openBtn = root.querySelector('[data-info-open]');
      var overlay = root.querySelector('[data-info-overlay]');
      var box = root.querySelector('[data-info-box]');
      var closeBtn = root.querySelector('[data-info-close]');
      if (!openBtn || !overlay || !box) return;

      function open() {
        overlay.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        box.focus();
        document.addEventListener('keydown', onKey);
      }

      function close() {
        overlay.setAttribute('hidden', '');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        openBtn.focus();
      }

      function onKey(e) {
        if (e.key === 'Escape') {
          close();
          return;
        }
        if (e.key === 'Tab') {
          var focusables = box.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (focusables.length === 0) return;
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.info-modal'), initModal);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.info-modal');
      if (el) initModal(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    function initPNutri(root) {
      if (root.dataset.pnutriInit) return;
      root.dataset.pnutriInit = '1';
      var openBtn = root.querySelector('[data-pnutri-open]');
      var overlay = root.querySelector('[data-pnutri-overlay]');
      var box = root.querySelector('[data-pnutri-box]');
      var closeBtn = root.querySelector('[data-pnutri-close]');
      if (!openBtn || !overlay || !box) return;

      function open() {
        overlay.style.cssText = root.style.cssText;
        document.body.appendChild(overlay);
        overlay.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
        box.focus();
        document.addEventListener('keydown', onKey);
      }

      function close() {
        overlay.setAttribute('hidden', '');
        document.body.style.overflow = '';
        document.removeEventListener('keydown', onKey);
        if (root.contains(openBtn)) {
          root.appendChild(overlay);
        }
        openBtn.focus();
      }

      function onKey(e) {
        if (e.key === 'Escape') {
          close();
          return;
        }
        if (e.key === 'Tab') {
          var f = box.querySelectorAll('button, a[href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
          if (f.length === 0) return;
          var first = f[0];
          var last = f[f.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        }
      }

      openBtn.addEventListener('click', open);
      if (closeBtn) closeBtn.addEventListener('click', close);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close();
      });
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.pnutri'), initPNutri);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      Array.prototype.forEach.call(e.target.querySelectorAll('.pnutri'), initPNutri);
    });
  })();

  (function () {
    function relocateUnderMedia() {
      Array.prototype.forEach.call(document.querySelectorAll('.product__under-media'), function (under) {
        var product = under.closest('.product');
        if (!product) return;
        var media = product.querySelector('.product__media-wrapper');
        if (!media) return;
        if (window.matchMedia('(max-width: 749px)').matches) {
          if (under.parentNode !== product) product.appendChild(under);
        } else {
          if (under.parentNode !== media) media.appendChild(under);
        }
      });
    }
    relocateUnderMedia();
    window.addEventListener('resize', relocateUnderMedia);
    document.addEventListener('shopify:section:load', relocateUnderMedia);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-spotlight"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRspot(root) {
      if (root.dataset.rspotInit) return;
      root.dataset.rspotInit = '1';

      var slidesWrap = root.querySelector('[data-rspot-slides]');
      if (!slidesWrap) return;
      var slides = Array.prototype.slice.call(slidesWrap.querySelectorAll('[data-rspot-slide]'));
      if (slides.length === 0) return;

      var prev = root.querySelector('[data-rspot-prev]');
      var next = root.querySelector('[data-rspot-next]');
      var dots = Array.prototype.slice.call(root.querySelectorAll('[data-rspot-dot]'));
      var index = 0;

      function show(newIndex) {
        var len = slides.length;
        index = ((newIndex % len) + len) % len;

        slides.forEach(function (slide, i) {
          var active = i === index;
          slide.hidden = !active;
          if (active) {
            slide.removeAttribute('aria-hidden');
          } else {
            slide.setAttribute('aria-hidden', 'true');
          }
        });

        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      if (prev) {
        prev.addEventListener('click', function () {
          show(index - 1);
        });
      }

      if (next) {
        next.addEventListener('click', function () {
          show(index + 1);
        });
      }

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          show(i);
        });
      });

      show(0);
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.rspot'), initRspot);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.rspot');
      if (el) initRspot(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["transform-timeline"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(v, min, max) { return Math.max(min, Math.min(max, v)); }

    function initTimeline(root) {
      var items = root.querySelector('.transform-timeline__items');
      var line = root.querySelector('.transform-timeline__line');
      var fill = root.querySelector('.transform-timeline__line-fill');
      if (!items || !line || !fill) return;
      var markers = Array.prototype.slice.call(root.querySelectorAll('.transform-timeline__item'));
      if (markers.length === 0) return;

      function update() {
        var itemsRect = items.getBoundingClientRect();
        var firstM = markers[0].querySelector('.transform-timeline__marker').getBoundingClientRect();
        var lastM = markers[markers.length - 1].querySelector('.transform-timeline__marker').getBoundingClientRect();
        var firstCenter = firstM.top + firstM.height / 2;
        var lastCenter = lastM.top + lastM.height / 2;
        var topOffset = firstCenter - itemsRect.top;
        var length = Math.max(1, lastCenter - firstCenter);

        line.style.top = topOffset + 'px';
        line.style.height = length + 'px';
        fill.style.top = topOffset + 'px';

        var trigger = window.innerHeight * 0.6;
        var progress = clamp((trigger - firstCenter) / length, 0, 1);
        fill.style.height = (progress * length) + 'px';

        markers.forEach(function (item) {
          var m = item.querySelector('.transform-timeline__marker').getBoundingClientRect();
          var center = m.top + m.height / 2;
          if (center <= trigger) {
            item.classList.add('is-active');
          } else {
            item.classList.remove('is-active');
          }
        });
      }

      var ticking = false;
      function onScroll() {
        if (!ticking) {
          window.requestAnimationFrame(function () { update(); ticking = false; });
          ticking = true;
        }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll);
      update();
    }

    function initAll() {
      Array.prototype.forEach.call(document.querySelectorAll('.transform-timeline'), initTimeline);
    }

    if (document.readyState !== 'loading') {
      initAll();
    } else {
      document.addEventListener('DOMContentLoaded', initAll);
    }

    document.addEventListener('shopify:section:load', function (e) {
      var el = e.target.querySelector('.transform-timeline');
      if (el) initTimeline(el);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
